<script>
import pdf from "vue-pdf";

export default {
  name: "DocumentViewerSection",
  components: {
    pdf
  },

  props: {
    achievement: {
      type: [Object, undefined],
      default: {},
    },

    visible: {
      type: Boolean
    },
  },

  watch: {
    'visible': function (newVisible, oldVisible) {
       if (!newVisible) {
         this.numPages = 1;
         this.widthViewer = 100;
       }
    },
  },

  data() {
    return {
      numPages: 1,
      widthViewer: 100,
    };
  },

  computed: {
    achievementFileUrl() {
      return this.achievement?.file?.url;
    },

    pdfLoading() {
      if (_.isNil(this.achievementFileUrl)) return null;
      return pdf.createLoadingTask(this.achievementFileUrl)
    },

    isAchievementFileTypePdf() {
      return this.achievement?.file_type === 'application/pdf'
    },

    percentWidthViewer() {
      return this.widthViewer + "%";
    },
  },

  methods: {

    getNumberPagesTest(numPages) {
      if(_.isNil(numPages)) return;
      this.numPages = numPages;
    },

  }
}
</script>

<template>
  <div class="fill-height">
    <v-card-title class="py-1">
      <v-text-field
        v-model="widthViewer"
        type="number"
        outlined
        dense
        color="teal darken-3"
        class="rounded-xl ml-3"
        style="max-width: 150px"
        append-icon="fa-search"
        flat
        label="Увеличение"
        min="0"
        step="25"
        hide-details
      >

      </v-text-field>

      <v-spacer/>

      <v-btn
        :href="achievementFileUrl"
        target="_blank"
        color="teal darken-3"
        outlined
        small
        class="rounded-xl"
      >
        Открыть
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text
      class="file-viewer mt-0 pt-0"
    >
      <div class="text" v-show="isAchievementFileTypePdf">
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="pdfLoading"
          :page="i"
          @num-pages="getNumberPagesTest"
          :style="{'width': percentWidthViewer}"
        >
        </pdf>
      </div>
      <div v-show="!isAchievementFileTypePdf">
        <v-img
          :src="achievementFileUrl"
          :width="`${widthViewer * 5}px`"
        >
        </v-img>
      </div>
    </v-card-text>
  </div>
</template>

<style scoped>
  .file-viewer {
    height: 85%;
    overflow: auto;
  }
</style>